// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header__top {
    padding: 10px 0px;
    background: #03A5D5;
    color:#fff;
}
.header__top__left {
    display: flex;
    align-items: center;
    column-gap: 1rem;
}
.header__top__left span {
    font-size: 0.9rem;
}
.header__top__help {
    display: flex;
    align-items: center;
    column-gap: 0.4rem;
}
.header__top__help i {
    background: #fff;
    color: #03A5D5;
    padding: 2px 4px;
    border-radius: 50px;
    font-size: 0.7rem;
}
.header__top__right a {
    text-decoration: none;
    color: #fff;
    font-size:0.9rem;
}
.header__top__right a:hover {
    color: #fff;
    cursor: pointer;
}
.header__top__right button:hover {
    color: #fff !important;
    background: #FF7F50 !important;
}
.dropdown-item label:hover {
    cursor: pointer;
}

/*============== header middle style ==============*/

.header__middle {
    padding: 20px 0px;
}
.logo h1 a span {
    font-size: 1.5rem;
}
.logo h1 a i {
    font-size: 2.2rem;
}
.logo h1 a {
    text-decoration: none;
    color: #03A5D5;
    font-weight: 700;
}
.logo h1 {
    line-height: 1.4rem;
}
.header__location span i {
    font-size: 2.2rem;
    color: #FF7F50;
}
.header__location-content h4 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #03A5D5;
}
.header__location-content h6 {
    font-weight: 600;
}
.header__btn {
    background: #03A5D5!important;
    padding:10px 20px;
    border: none;
    outline: none;
    border-radius: 5px;
}
.header__btn a {
    display: flex;
    align-items: center;
    column-gap: 0.4rem;
    text-decoration: none;
    color: #fff;
    justify-content: end;
    font-size: 0.9rem;
}
.header__btn a:hover {
    color: #FF7F50;
}

/*================== main navbar styles ================== */
.main__navbar {
    padding: 15px 0px;
    background: #03A5D5;
}
.mobile__menu i {
    color: #fff;
    font-size: 1.3rem;
    cursor: pointer;
}
.mobile__menu {
    display: none;
}
.menu {
    display: flex;
    align-items: center;
    column-gap: 2.7rem;
}
.nav__item {
    color: #fff;
    text-decoration: none;
    transition: .3rem;
}
.nav__item:hover {
    color: #FF7F50;
    font-weight: 600;
}
.nav__active {
    color: #ef4a0e;
    font-weight: 600;
}
@media only screen and (max-width: 768px){
    .header__top, 
    .header__middle, 
    .nav__right {
        display: none;
    }
    .mobile__menu {
        display: block;
    }
    .navigation {
        background: rgb(0, 13, 107, 0.6);
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        display: none;
    }
    .menu {
        width: 250px;
        height: 100%;
        background: #fff;
        display: flex;
        align-items: center;
        flex-direction: column;
        row-gap: 2rem;
        justify-content: center;
    }
    .menu a {
        color: #03A5D5;
        font-weight: 600;
        font-size: 0.9rem;
    }
    .menu__active {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;;AAEA,oDAAoD;;AAEpD;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI;;;QAGI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,gCAAgC;QAChC,WAAW;QACX,YAAY;QACZ,eAAe;QACf,MAAM;QACN,OAAO;QACP,aAAa;QACb,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".header__top {\n    padding: 10px 0px;\n    background: #03A5D5;\n    color:#fff;\n}\n.header__top__left {\n    display: flex;\n    align-items: center;\n    column-gap: 1rem;\n}\n.header__top__left span {\n    font-size: 0.9rem;\n}\n.header__top__help {\n    display: flex;\n    align-items: center;\n    column-gap: 0.4rem;\n}\n.header__top__help i {\n    background: #fff;\n    color: #03A5D5;\n    padding: 2px 4px;\n    border-radius: 50px;\n    font-size: 0.7rem;\n}\n.header__top__right a {\n    text-decoration: none;\n    color: #fff;\n    font-size:0.9rem;\n}\n.header__top__right a:hover {\n    color: #fff;\n    cursor: pointer;\n}\n.header__top__right button:hover {\n    color: #fff !important;\n    background: #FF7F50 !important;\n}\n.dropdown-item label:hover {\n    cursor: pointer;\n}\n\n/*============== header middle style ==============*/\n\n.header__middle {\n    padding: 20px 0px;\n}\n.logo h1 a span {\n    font-size: 1.5rem;\n}\n.logo h1 a i {\n    font-size: 2.2rem;\n}\n.logo h1 a {\n    text-decoration: none;\n    color: #03A5D5;\n    font-weight: 700;\n}\n.logo h1 {\n    line-height: 1.4rem;\n}\n.header__location span i {\n    font-size: 2.2rem;\n    color: #FF7F50;\n}\n.header__location-content h4 {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: #03A5D5;\n}\n.header__location-content h6 {\n    font-weight: 600;\n}\n.header__btn {\n    background: #03A5D5!important;\n    padding:10px 20px;\n    border: none;\n    outline: none;\n    border-radius: 5px;\n}\n.header__btn a {\n    display: flex;\n    align-items: center;\n    column-gap: 0.4rem;\n    text-decoration: none;\n    color: #fff;\n    justify-content: end;\n    font-size: 0.9rem;\n}\n.header__btn a:hover {\n    color: #FF7F50;\n}\n\n/*================== main navbar styles ================== */\n.main__navbar {\n    padding: 15px 0px;\n    background: #03A5D5;\n}\n.mobile__menu i {\n    color: #fff;\n    font-size: 1.3rem;\n    cursor: pointer;\n}\n.mobile__menu {\n    display: none;\n}\n.menu {\n    display: flex;\n    align-items: center;\n    column-gap: 2.7rem;\n}\n.nav__item {\n    color: #fff;\n    text-decoration: none;\n    transition: .3rem;\n}\n.nav__item:hover {\n    color: #FF7F50;\n    font-weight: 600;\n}\n.nav__active {\n    color: #ef4a0e;\n    font-weight: 600;\n}\n@media only screen and (max-width: 768px){\n    .header__top, \n    .header__middle, \n    .nav__right {\n        display: none;\n    }\n    .mobile__menu {\n        display: block;\n    }\n    .navigation {\n        background: rgb(0, 13, 107, 0.6);\n        width: 100%;\n        height: 100%;\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: 9999;\n        display: none;\n    }\n    .menu {\n        width: 250px;\n        height: 100%;\n        background: #fff;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        row-gap: 2rem;\n        justify-content: center;\n    }\n    .menu a {\n        color: #03A5D5;\n        font-weight: 600;\n        font-size: 0.9rem;\n    }\n    .menu__active {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
